module.exports = __webpack_public_path__ + "img/scroll.9f053ce7.svg";